import React from "react";

// grid 系セクションの描画を担当します。
// genka の左右2ペイン、受注/納品ヘッダ、配色 masterDetail をここで吸収します。
export function renderGridSectionBody({
    section,
    gridSectionPanel,
    hasGridColumns,
    rowStyle,
    renderContents,
    renderTotalGrid,
    renderGenkaHeader,
    renderDemandHeader,
    buildDemandColumns,
    buildNouhinHeaderColumns,
    buildGenkaFixedColumns,
    buildBrandNameGridColumns,
    buildDemeritGridColumns,
    colorwayDetailParams,
    toStableAutoHeightPanel,
    genkaGridFixedHeight,
    isDemandSectionId,
    sectionTotalType,
    isEmpty
}) {
    if (!hasGridColumns) {
        return (
            <div style={{ minHeight: 120, border: "1px solid #d0d0d0", borderRadius: 4, backgroundColor: "#fafafa" }}>
            </div>
        );
    }

    const totaltype = sectionTotalType(section, gridSectionPanel);

    // 原価は左右2ペインの専用レイアウトです。
    if (section.totalLayout === "side" && !isEmpty(totaltype)) {
        const stableGenkaPanel = toStableAutoHeightPanel(gridSectionPanel, section.id);
        const querySetColumn = (colDef) => buildGenkaFixedColumns(colDef, section.id);

        return (
            <div>
                {section.id === "genka" ? renderGenkaHeader() : null}
                <div style={{ display: "flex", gap: 0, alignItems: "flex-start" }}>
                    <div className="kakou-genka-left-grid" style={{ flex: 1, minWidth: 0 }}>
                        {renderContents({
                            panel: stableGenkaPanel,
                            forceNormalLayout: true,
                            fixedNormalHeight: genkaGridFixedHeight(stableGenkaPanel),
                            getRowStyle: rowStyle,
                            hideRowNumbers: true,
                            rowDrag: false,
                            QuerySetColumn: querySetColumn,
                            forceGenkaPanel: true
                        })}
                    </div>
                    {renderTotalGrid(section, stableGenkaPanel, totaltype, true)}
                </div>
            </div>
        );
    }

    const isColorwaySection = section.id === "sozai_haisyoku" || section.id === "fuzoku_haisyoku";
    const renderGridPanel = toStableAutoHeightPanel(gridSectionPanel, section.id);
    const querySetColumn = (colDef) => {
        let next = buildDemandColumns(colDef, renderGridPanel);
        if (section.id === "nouhinyotei") {
            next = buildNouhinHeaderColumns(next, renderGridPanel);
        }
        if (section.id === "genka") {
            next = buildGenkaFixedColumns(next, section.id);
        }
        if (section.id === "brandname") {
            next = buildBrandNameGridColumns(next);
        }
        if (section.id === "demerit") {
            next = buildDemeritGridColumns(next);
        }
        return next;
    };

    return (
        <div>
            {section.id === "genka" ? renderGenkaHeader() : null}
            {isDemandSectionId(section.id) ? renderDemandHeader(section.id) : null}
            {isColorwaySection ? (
                renderContents({
                    panel: renderGridPanel,
                    masterDetail: true,
                    detailCellRendererParams: colorwayDetailParams(section.id)
                })
            ) : (
                <div className={isDemandSectionId(section.id) ? "kakou-demand-grid" : ""}>
                    {renderContents({
                        panel: renderGridPanel,
                        getRowStyle: rowStyle,
                        hideRowNumbers: isDemandSectionId(section.id) || section.id === "genka",
                        rowDrag: (isDemandSectionId(section.id) || section.id === "genka") ? false : undefined,
                        QuerySetColumn: querySetColumn
                    })}
                </div>
            )}
            {renderTotalGrid(section, renderGridPanel, totaltype, false, section.id === "sijisu")}
        </div>
    );
}
